import { FormRows } from '@acorns/web-components'
import { FormRowProps } from '@acorns/web-components/dist/Form/FormBuilder/types'
import * as Sentry from '@sentry/browser'
import format from 'date-fns/format'

import { sendToSentry } from 'utils/errors'
import { FlowRoute } from 'utils/FlowProvider/types'
import { parseGraphQLError } from 'utils/form-utils'
import { getGeneralError } from 'utils/getGeneralError'
import { dobMask } from 'utils/text-masks/dob'
import { phoneMask } from 'utils/text-masks/phone'

// Backend expects YYYY/MM/DD
const formatDob = dob => format(dob, 'YYYY/MM/DD')

export const handleSubmit = (values, { props, ...ownProps }) => {
  ownProps.setSubmitting(true)
  Sentry.addBreadcrumb({ message: 'User attempting to submit personal info at /personal-info' })
  const variables = {
    ...values,
    dob: formatDob(values.dob),
  }

  return props
    .updatePersonalInfo({
      variables,
    })
    .then(() => {
      props.route({
        from: FlowRoute.PersonalInfo,
        action: 'continue',
      })
    })
    .catch(error => {
      const retryHandler = () => {
        props.closeErrorModal()
        ownProps.submitForm()
      }
      const { title, message, actions, image } = getGeneralError(error, props, retryHandler)
      props.showErrorModal({ title, message, actions, image })

      sendToSentry(error)
      ownProps.setSubmitting(false)

      const errorCode = parseGraphQLError(error)
    })
}

export default (data): FormRows => {
  const rows: FormRowProps[] = [
    [
      {
        label: 'Legal First Name *',
        name: 'firstName',
        type: 'text',
        placeholder: 'John',
      },
      {
        label: 'Legal Last Name *',
        name: 'lastName',
        type: 'text',
        placeholder: 'Doe',
      },
    ],
    [
      {
        label: 'Phone Number *',
        mask: phoneMask,
        name: 'phoneNumber',
        placeholder: '(123) 456-7890',
        type: 'text',
        inputMode: 'tel',
        guide: false,
        helperText:
          'We’ll use this number to protect your account by sending  two-factor authentication verification codes. Standard message rates may apply.',
      },
      {
        label: 'Birthday *',
        name: 'dob',
        mask: dobMask,
        placeholder: 'MM/DD/YYYY',
        type: 'text',
        inputMode: 'numeric',
        guide: false,
      },
    ],
    [
      {
        label: "I'm a U.S. Citizen",
        name: 'usCitizen',
        topLabel: 'Citizenship *',
        type: 'checkbox',
      },
    ],
  ]

  // If user data already loaded and the first and last names are already present, remove the first row (first and last names)
  if (!data.loading && data.user && data.user.firstName && data.user.lastName) {
    rows.shift()
  }

  return rows
}
